module.exports = __webpack_public_path__ + "static/CelPrimeraInstancia-6164a5f4146aa13a20998cbee6541eb3.mp4";